module.exports = __webpack_public_path__ + "static/media/Authenticity.93c9f661.png";